import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';
import { EvaluablePut } from './actions';

import messages from './messages';
import { ACTION, RTM_OPERATION, RTM_REPLY } from './constants';

function* storeEvaluable({ response: { evaluable } }) {
  yield put(EvaluablePut(evaluable.elementId, evaluable.elementType, evaluable.evaluationMode));
}

export function* sendRequest(connection, rtmMessages = {}, action) {
  const response = yield call(connection.fetch.bind(connection), {
    type: rtmMessages.sendMessage,
    elementId: action.elementId,
    elementType: action.elementType,
    evaluationMode: action.evaluationMode,
  });
  const responseAction = rtmMessages[response.type];

  if (!responseAction) {
    yield call(handleError, response, messages.defaultError);
  } else {
    yield call(responseAction, response);
  }
}

export function* handleError(err, message) {
  yield put(pushToast({
    type: 'simple',
    message: err.message || <FormattedMessage {...message} />,
  }));
}

export default function* (connection) {
  yield takeEvery(ACTION.AUTHOR_EVALUABLE_GET, catchErrors, sendRequest, connection, {
    sendMessage: RTM_OPERATION.AUTHOR_EVALUABLE_GET,
    [RTM_REPLY.AUTHOR_EVALUABLE_GET_OK]: (response) => storeEvaluable(response),
    [RTM_REPLY.AUTHOR_EVALUABLE_GET_ERROR]: handleError });

  yield takeEvery(ACTION.AUTHOR_EVALUABLE_SET, catchErrors, sendRequest, connection, {
    sendMessage: RTM_OPERATION.AUTHOR_EVALUABLE_SET,
    [RTM_REPLY.AUTHOR_EVALUABLE_SET_OK]: (response) => storeEvaluable(response),
    [RTM_REPLY.AUTHOR_EVALUABLE_SET_ERROR]: handleError });
}
